import {
	IBAN_COMPONENT_ELEMENT_ID,
	makeComplexDataTestId,
} from '@dealstack/shared/tests/testElementIds.ts';
import { Button, Flex, Text } from '@mantine/core';
import React, { memo } from 'react';
import ReactCountryFlag from 'react-country-flag';
import type { BankAccountCountryOption } from '../types.ts';
import { Icon } from '../../fundament/Icon/Icon.tsx';

export const BANK_COUNTRY_OPTION_HEIGHT = 36;

interface Props {
	option: BankAccountCountryOption;
	isSelected: boolean;
	onHighlight: (countryCode: string) => void;
}

export const BankCountryOption = memo(({ option, isSelected, onHighlight }: Props) => (
	<Button
		onClick={() => onHighlight(option.value)}
		variant={isSelected ? 'outline' : 'subtle'}
		color={isSelected ? 'blue.6' : undefined}
		c="blue.6"
		justify="space-between"
		fullWidth
		h={BANK_COUNTRY_OPTION_HEIGHT}
		data-testid={makeComplexDataTestId(
			IBAN_COMPONENT_ELEMENT_ID.BANK_COUNTRY_OPTION,
			option.value
		)}
		rightSection={isSelected ? <Icon variant="tick-circle" size="vlg" /> : null}
	>
		<Flex justify="flex-start" align="center" gap="0.75rem" miw={0}>
			<ReactCountryFlag countryCode={option.value} svg style={{ width: '1.5em' }} />

			<Text size="md" c="dark.8" fw={600} truncate>
				{option.label}
			</Text>
		</Flex>
	</Button>
));

BankCountryOption.displayName = 'BankCountryOption';
